import { createFileRoute } from '@tanstack/react-router'
import { LegacyLocaleShim } from '~/components/marketing/legacy-locale-shim'
import { PrivacyPage } from '~/components/marketing/privacy-page'

const SITE_URL = 'https://planno.app'
const CANONICAL = '/politica-de-privacidade'

export const Route = createFileRoute('/pt/politica-de-privacidade')({
  component: PtPrivacyShim,
  head: () => ({
    links: [{ href: `${SITE_URL}${CANONICAL}`, rel: 'canonical' }],
    meta: [{ content: 'noindex,follow', name: 'robots' }],
  }),
})

function PtPrivacyShim() {
  return (
    <LegacyLocaleShim canonicalPath={CANONICAL}>
      <PrivacyPage />
    </LegacyLocaleShim>
  )
}
